import { entityNormalizedField } from "./entity-normalized-field";
import { pad, sortBy, toString } from "lodash";
export var paddedListPriority = function (entity) {
  return pad(toString(entity.listPriority || 99999999) || '', 8, '0');
};
export var entityGridNameSort = function (items) {
  var sortFunc = function (entity) {
    return paddedListPriority(entity) + entityNormalizedField('name')(entity);
  };
  return sortBy(items, sortFunc);
};
export var entityGridMostRecentSort = function (items) {
  return sortBy(items, function (entity) {
    return paddedListPriority(entity) + entity.published;
  }).reverse();
};
export var entityGridChronoSort = function (items) {
  return sortBy(items, function (entity) {
    return paddedListPriority(entity) + entity.published;
  });
};